// Zahlen- und Betragsformat für den Immobilienbereich (de-DE).

const EUR2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const EUR0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
const ZAHL = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });

/** „1.000,00 €“; mit `vorzeichen` „+1.000,00 €“ bzw. „−…“ (echtes Minuszeichen); `nachkomma: 0` → „1.000 €“. */
export function eur(betrag: number, opts: { vorzeichen?: boolean; nachkomma?: 0 | 2 } = {}): string {
  const fmt = opts.nachkomma === 0 ? EUR0 : EUR2;
  const wert = Math.abs(betrag) < 0.005 ? 0 : betrag;
  const text = fmt.format(Math.abs(wert));
  const zeichen = wert < 0 ? '−' : opts.vorzeichen && wert > 0 ? '+' : '';
  return `${zeichen}${text} €`;
}

/** „350 m²“ bzw. „111,26 m²“. */
export function qm(flaeche: number): string {
  return `${ZAHL.format(flaeche)} m²`;
}

/** Heute als ISO-Datum (lokale Zeit). */
export function heuteIso(jetzt: Date = new Date()): string {
  const j = jetzt.getFullYear();
  const m = String(jetzt.getMonth() + 1).padStart(2, '0');
  const t = String(jetzt.getDate()).padStart(2, '0');
  return `${j}-${m}-${t}`;
}

/** Initialen aus einem Namen: „Marc Schwede“ → „MS“. */
export function initialen(name: string | null | undefined): string {
  // nur Wörter, die mit Buchstabe oder Ziffer beginnen („Abfallwirtschaft (LK)“ → „AL“, nicht „A(“)
  const teile = (name ?? '').trim().split(/\s+/).map(t => t.replace(/^[^\p{L}\p{N}]+/u, '')).filter(Boolean);
  if (teile.length === 0) return '?';
  if (teile.length === 1) return (teile[0] ?? '').slice(0, 2).toUpperCase();
  return `${(teile[0] ?? '')[0] ?? ''}${(teile[teile.length - 1] ?? '')[0] ?? ''}`.toUpperCase();
}
